import React, { useEffect } from "react";
import SocialLinks from "./SocialLinks";
import FooterBottomMenus from "./FooterBottomMenus";
import FooterTopMenus from "./FooterTopMenus";
import FooterMiddleMenus from "./FooterMiddleMenus";
import { useLanguageTranslation } from "../../../hooks/useLanguageTranslation";
import { useGetFeedbackDataMutation } from "../../../redux/services/apiHome";
import VisitorsCount from "./FooterBottom/VisitorsCount";
import LastUpdatedOn from "./FooterBottom/LastUpdatedOn";
import useFetchIp from "../../../hooks/useFetchIp";
import FooterAddress from "./FooterAddress";

const FooterSection = () => {
  const { getText } = useLanguageTranslation();

  const { ip } = useFetchIp();

  const [postIpFunction] = useGetFeedbackDataMutation();

  useEffect(() => {
    if (ip) {
      const payload = {
        visitors_ip: ip,
        visitors_url: "/react-app",
        visitors_page_title: "Home",
      };
      postIpFunction({ url: "/v1/react_visitor", payload });
    }
  }, [ip, postIpFunction]);

  return (
    <footer>
      <div className="footer-top-sec">
        <div className="container">
          <div className="row">
            <FooterTopMenus />
            <SocialLinks />
          </div>
        </div>
      </div>

      <div className="footer-middle-sec">
        <div className="container">
          <div className="row wow zoomIn">
            <div className="col-12 col-sm-12 col-md-6 col-lg-6 print-footm1">
              <div className="titlesec">
                <div className="foot-title">
                  {getText("Quick Links", "त्वरित लिंक")}
                </div>
              </div>
              <FooterMiddleMenus />
            </div>
            <FooterAddress />
          </div>
        </div>
      </div>

      <div className="footer-bottom-sec">
        <div className="container">
          <div className="row">
            <div className="col-12 col-sm-12 col-md-9 col-lg-9 copyright-sec copyright wow fadeInLeft">
              <FooterBottomMenus />
              <p>
                {getText(
                  "Copyright © 2026 North Eastern Electric Power Corporation Ltd., Government of India. All rights reserved",
                  "कॉपीराइट © 2026 नॉर्थ  ईस्टर्न  इलेक्ट्रिक  पावर  कॉर्पोरेशन  लिमिटेड, भारत सरकार। सर्वाधिकार सुरक्षित",
                )}
              </p>
            </div>
            <div className="col-12 col-sm-12 col-md-3 col-lg-3 visitor-sec  wow fadeInLeft">
              <p className="mb-2">
                ISO 9001, ISO 14001, ISO 27001 and ISO 45001 <br /> CIN:
                U40101ML1976GOI001658
              </p>
              <VisitorsCount />
              <LastUpdatedOn />
            </div>
            {/* <div className="col-12 col-sm-12 col-md-12 col-lg-12 copyright">
              <p>
                {getText(
                  "Copyright © 2024 North Eastern Electric Power Corporation Ltd., Government of India. All rights reserved",
                  "कॉपीराइट © 2024 उत्तर पूर्वी विद्युत निगम लिमिटेड, भारत सरकार। सर्वाधिकार सुरक्षित"
                )}
              </p>
            </div> */}
          </div>
        </div>
      </div>
    </footer>
  );
};

export default FooterSection;
